import { Directive, ElementRef, Renderer2, OnInit } from "@angular/core";

@Directive({
  selector: "[isRequired]",
})
export class IsRequiredDirective implements OnInit {
  constructor(private ref: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    const asterisk = this.renderer.createElement("span");
    const text = this.renderer.createText(" *");
    this.renderer.addClass(asterisk, "is-required");
    this.renderer.addClass(asterisk, "is-required-asterisk");
    this.renderer.appendChild(asterisk, text);
    this.renderer.appendChild(this.ref.nativeElement, asterisk);
  }
}
